import { AnchorHTMLAttributes, PropsWithChildren } from 'react';

import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { gql } from '@apollo/client';

import { FileReportTableProcessingReport } from './__generated__/FileReportTable';

const downloadLinkClass =
  'ml-10 rounded bg-success-default px-2 py-px text-gray-900 no-underline ' +
  'transition-colors duration-200 hover:bg-download-link-hover hover:no-underline hover:[color:unset] ' +
  'active:bg-download-link-active active:[color:unset]';

const DownloadLink = ({
  children,
  ...props
}: PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>>): JSX.Element => {
  return (
    <a className={downloadLinkClass} {...props}>
      {children} <FontAwesomeIcon icon={faDownload} />
    </a>
  );
};

const FileReportTableFragments = {
  processingReport: gql`
    fragment FileReportTableProcessingReport on ProcessingReport {
      new_count
      flagged_count
      duplicate_count
      failed_count
      flagged_records_csv_url
      flagged_records_excel_url
      failed_records_csv_url
      failed_records_excel_url
    }
  `,
};

type FileReportTableProps = {
  processingReport: FileReportTableProcessingReport;
};

function FileReportTable({ processingReport }: FileReportTableProps): JSX.Element {
  const flaggedReportLinkRow =
    processingReport.flagged_count &&
    processingReport.flagged_count > 0 &&
    processingReport.flagged_records_csv_url != null &&
    processingReport.flagged_records_excel_url != null ? (
      <span>
        <DownloadLink href={processingReport.flagged_records_csv_url}>CSV</DownloadLink>
        <DownloadLink href={processingReport.flagged_records_excel_url}>Excel</DownloadLink>
      </span>
    ) : null;

  const failedReportLinkRow =
    processingReport.failed_count &&
    processingReport.failed_count > 0 &&
    processingReport.failed_records_csv_url != null &&
    processingReport.failed_records_excel_url != null ? (
      <span>
        <DownloadLink href={processingReport.failed_records_csv_url}>CSV</DownloadLink>
        <DownloadLink href={processingReport.failed_records_excel_url}>Excel</DownloadLink>
      </span>
    ) : null;

  return (
    <div className="map-table flex flex-col flex-nowrap justify-start gap-2 pb-4">
      <tbody>
        <tr>
          <td>New Records:</td>
          <td>{processingReport.new_count}</td>
        </tr>
        <tr>
          <td>Flagged Records:</td>
          <td>
            {processingReport.flagged_count}
            {flaggedReportLinkRow}
          </td>
        </tr>
        <tr>
          <td>Duplicate Records:</td>
          <td>{processingReport.duplicate_count}</td>
        </tr>
        <tr>
          <td>Failed Records:</td>
          <td>
            {processingReport.failed_count}
            {failedReportLinkRow}
          </td>
        </tr>
      </tbody>
    </div>
  );
}

export default FileReportTable;

export { FileReportTableFragments };
